import React from "react";
import {
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailPanel,
    DetailKvTable,
} from "../../../../components/detailLayout";
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";

export const INCIDENT_REPORT_FIELDS = [
    {key: "incidentEffect", title: "장애현상"},
    {key: "causeAnalysis", title: "장애원인 분석"},
    {key: "workImpact", title: "업무 영향도"},
    {key: "damage", title: "피해상황"},
    {key: "plans", title: "향후계획"},
    {key: "etc", title: "비고"},
];

export function IncidentRequestInfoPanel({incident, assets, handler}) {
    return (
        <DetailPanel title={"장애요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdAt"} value={incident.createdAt} />
                        </Th_title>
                        <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdBy"} value={incident.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedAt"} value={incident.updatedAt} />
                        </Th_title>
                        <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedBy"} value={incident.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애 제목"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"title"} value={incident.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requester"} value={incident.requester} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                            <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애유형"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentCode"} value={incident.incidentCode?.name} />
                        </Th_title>
                        <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentRequest"} value={incident.incidentRequest} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애구분"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentType"} value={incident.incidentType} />
                        </Th_title>
                        <Th_title title={"장애등급"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentLevel"} value={incident.incidentLevel} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애인지"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"incidentAcceptCode"} value={incident.incidentAcceptCode} />
                            <ReadOnlyInputBasic target={"incidentAcceptText"} value={incident.incidentAcceptText} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장애기간"} colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker time data={incident.incidentStartDate} readonly />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker time data={incident.incidentEndDate} readonly />
                            </div>
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"장애내용"} colspan={3} className="fieldset-td">
                            <div className="align-text-div">{incident.incidentContent}</div>
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );
}

export function IncidentReportBodyPanel({incident, incidentReport, setIncidentReport, readOnly = false}) {
    const isRegistered = Boolean(incidentReport?.id);

    return (
        <DetailPanel title={"장애보고서 내역"} className="incident-report-body-panel">
            <DetailKvTable>
                <tbody>
                    {INCIDENT_REPORT_FIELDS.map(({key, title}) => (
                        <tr key={key} className="asset-detail-kv-row--auto incident-report-kv-row">
                            <Th_title title={title} colspan={3} className="fieldset-td" auth={incident.auth?.update}>
                                {readOnly ? (
                                    <div className="align-text-div incident-report-kv-text">{incidentReport?.[key]}</div>
                                ) : (
                                    <div className="incident-report-kv-field">
                                        <SimmsTextArea
                                            onChange={(v) => inputOnChange(setIncidentReport, key, v, false)}
                                            data={incidentReport?.[key]}
                                            style={{width: "100%", minHeight: "80px", height: "80px", padding: "4px 0"}}
                                            placeHolder={isRegistered ? "" : "데이터를 입력해주세요"}
                                        />
                                    </div>
                                )}
                            </Th_title>
                        </tr>
                    ))}
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );
}
